import React from 'react'
import c from 'classnames'

import Tag from 'discada/dist/Tag'
import Icon from 'discada/dist/Icon'

import './Filter.scss'

export function Filter(props) {
  let { value, className, selected, toggleFilter = () => {} } = props

  return (
    <Tag
      compound
      className={c('filter', className, { selected })}
      onClick={() => toggleFilter(props)}
    >
      <Tag color="primary" size="small">
        {value}
      </Tag>
      {selected && <Tag color="primary" isDelete />}
    </Tag>
  )
}

export class FilterGroup extends React.Component {
  constructor(...args) {
    super(...args)

    this.state = {
      expanded: this.props.expanded,
      filters: this.props.filters || [],
    }

    this.toggle = () => this.setState({ expanded: !this.state.expanded })
  }

  static getDerivedStateFromProps(props, state) {
    return { ...state, ...props }
  }

  render() {
    let { label, className, toggleFilter } = this.props,
      { expanded, filters } = this.state

    return (
      <div
        className={c('filter-group', `filter-group-${label}`, className, {
          expanded,
        })}
      >
        <h4 onClick={this.toggle}>
          <Icon fixedWidth icon={expanded ? 'chevron-down' : 'chevron-right'} />{' '}
          {label}
        </h4>
        {expanded && (
          <div className="filters-list">
            {filters.map((f, i) => (
              <Filter key={i} {...f} toggleFilter={toggleFilter} />
            ))}
          </div>
        )}
      </div>
    )
  }
}
